import { Avatar } from "antd";
import { LoaderBar } from "components";
import { GetParticipantsCompetition } from "hooks";
import { UserSquare } from "phosphor-react";
import React from "react";
import styled from "styled-components";

const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f9ff; 
  padding: 10px 20px;
  border-radius: 8px;
  margin: auto;
  margin-bottom: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`;

const Text = styled.span`
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  color: #1a50e3;
`;

const CountContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: Roboto;
  font-weight: 600;
  font-size: 18px;
  color: #1a50e3;
  padding: 4px 6px;
  border-radius: 6px;
  background-color : white
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
`;

const StyledAvatar = styled(Avatar)`
  width: 36px;
  height: 36px;
  margin-right: 8px;
`;

const Title = styled.span`
  font-family: Roboto;
  font-weight: 600;
  font-size: 14px;
  color: #000;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const ListItem = ({ imageUrl, title }) => {
  return (
    <>
      <Container>
        <LeftSection>
          <StyledAvatar src={imageUrl} alt="Profile" />
          <Title>{title}</Title>
        </LeftSection>
        {/* <CommonColorButton title="Remove" variant="red" onClick={() => onRemove("Remove clicked")} /> */}
      </Container>
    </>
  );
};

export const Participants = ({ id }) => {
  const { data: participants, loading } = GetParticipantsCompetition(id)
  // const [currentPage, setCurrentPage] = useState(1);
  // const totalPages = 1;

  const handleRemove = (id) => {
    console.log(`Remove item with ID: ${id}`);
  };
  const count = participants?.length
  return (
    <div>
      <Card>
        <Text>Total Participants</Text>
        <CountContainer>
          <UserSquare size={28} />
          {count}
        </CountContainer>
      </Card>
      {
        loading ?
          <LoaderBar />
          :
          <>
            {participants.map((item) => (
              <ListItem
                key={item?._id}
                imageUrl={item?.image}
                title={item?.name}
                onRemove={() => handleRemove(item?._id)}
              />
            ))}
          </>
      }
      {/* <CustomPagination totalPages={totalPages} currentPage={currentPage} onPageChange={setCurrentPage} /> */}
    </div>
  )
}